import { render, staticRenderFns } from "./Page05Pcs.vue?vue&type=template&id=f7329e3a&scoped=true&"
import script from "./Page05Pcs.vue?vue&type=script&lang=js&"
export * from "./Page05Pcs.vue?vue&type=script&lang=js&"
import style0 from "./Page05Pcs.vue?vue&type=style&index=0&id=f7329e3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f7329e3a",
  null
  
)

export default component.exports
import {QToolbar,QToolbarTitle,QBtn,QSpace,QSelect,QIcon,QInput,QPopupProxy,QDate,QBar,QCircularProgress,QList,QItem,QItemSection,QMarkupTable,QItemLabel,QTooltip,QDialog,QCard,QCardSection,QSeparator,QCardActions,QInnerLoading,QSpinnerGears,QTable,Ripple,ClosePopup} from 'quasar'
component.options.components = Object.assign({QToolbar,QToolbarTitle,QBtn,QSpace,QSelect,QIcon,QInput,QPopupProxy,QDate,QBar,QCircularProgress,QList,QItem,QItemSection,QMarkupTable,QItemLabel,QTooltip,QDialog,QCard,QCardSection,QSeparator,QCardActions,QInnerLoading,QSpinnerGears,QTable}, component.options.components || {})
component.options.directives = Object.assign({Ripple,ClosePopup}, component.options.directives || {})
